module.exports = __webpack_public_path__ + "assets/images/3cfcbb1fbe80cd0f459f0813a692afd8.png";